import Header from "@components/layout/header";
import Footer from "@components/layout/footer";
import PublisherHero from "@public/publisher-application/publisher-hero.jpeg";
import { loadTranslation } from "@lib/utils";
import { GetStaticProps } from "next";
import Image from "next/image";
import { Trans } from "@lingui/macro";
import { t } from "@lingui/macro";
import { NextSeo } from "next-seo";

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const translation = await loadTranslation(
    locale,
    process.env.NODE_ENV == "production"
  );

  return { props: { translation } };
};

const PublisherApplicationPage = () => {
  const title = t`Register as a Publisher Today - Lumi News`;
  const description = t`Join our growing community of news publishers and share your content with a wider audience. Register your interest now.`;
  return (
    <>
      <NextSeo title={title} description={description} />

      <main>
        <Header showNewsStacks={false} />
        <div className="bg-white md:flex">
          <div className="relative mx-auto flex">
            <div className="absolute right-0 z-10 hidden h-full w-full bg-gradient-to-l from-white to-transparent md:block"></div>
            <Image
              src={PublisherHero}
              alt="publisher-hero-image"
              width={950}
              height={500}
              priority
            />
          </div>
          <div className="mt-8 px-4 md:my-auto md:w-1/2 md:pr-32">
            <p className="mb-4 font-poppins text-3xl font-bold text-primary">
              <Trans>Gain more readers while boosting revenue</Trans>
            </p>
            <p className="mb-4 font-poppins text-lg text-text-darkest">
              <Trans>
                We partner with local news outlets across the country to display
                their full articles natively on our platform.
              </Trans>
            </p>
            <div className="mb-4 flex items-start">
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSfMtBnhzPnGHtNwzP68Klb7N5al6pI854SPzD-v75wliK-jiQ/viewform?pli=1"
                target="_blank"
                className="w-full rounded-2xl bg-primary p-3 text-center font-sen text-white"
              >
                <Trans>Apply Now</Trans>
              </a>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default PublisherApplicationPage;
